<template>
    <v-card
        :color="$vuetify.theme.dark ? '#081426' : '#ffffff'"
        elevation="0"
        class="mt5-accounts-tabs all-trade-tab rounded-0"
    >
        <v-tabs
            :background-color="$vuetify.theme.dark ? '#081426' : '#ffffff'"
            v-model="model"
        >
            <v-tab class="px-0 ml-0" :href="`#tab-1`"> All </v-tab>
            <v-tab :href="`#tab-2`"> Live Account </v-tab>
            <!-- <v-tab :href="`#tab-3`"> My Investor Account </v-tab> -->
            <!-- <v-tab :href="`#tab-4`"> My Manager Account </v-tab> -->
            <v-tab :href="`#tab-5`"> Demo </v-tab>
        </v-tabs>
        <v-tabs-items v-model="model">
                <v-tab-item :value="`tab-1`">
                    <all-tabs></all-tabs>
                </v-tab-item>
                <v-tab-item :value="`tab-2`">
                    <live-account-tab></live-account-tab>
                </v-tab-item>
                <v-tab-item :value="`tab-3`">
                    <my-investor-account-tab></my-investor-account-tab>
                </v-tab-item>
                <v-tab-item :value="`tab-4`">
                    <manage-investor-account-tab></manage-investor-account-tab>
                </v-tab-item>
                <v-tab-item :value="`tab-5`">
                    <demo-account-tab></demo-account-tab>
                </v-tab-item>
        </v-tabs-items>
    </v-card>
</template>

<script>
import AllTabs from "./AllTabs.vue";
import DemoAccountTab from "./DemoAccountTab.vue";
import LiveAccountTab from "./LiveAccountTab.vue";
import ManageInvestorAccountTab from "./ManageInvestorAccountTab.vue";
import MyInvestorAccountTab from "./MyInvestorAccountTab.vue";

export default {
    components: {
        AllTabs,
        LiveAccountTab,
        MyInvestorAccountTab,
        ManageInvestorAccountTab,
        DemoAccountTab,
    },

    data() {
        return {
            model: "tab-1",
        };
    },
    mounted() {
        if (this.$route.query.tab) {
            this.model = `tab-${this.$route.query.tab}`;
        }
    },
    watch: {
        model: function (newModel) {
            const tab = newModel.split("-")[1];
            const currentQuery = { ...this.$route.query };
            if (tab) {
                currentQuery.tab = tab;
                this.$router.push({
                    path: this.$route.path,
                    query: currentQuery,
                });
            }
        },
        "$route.query.tab": function (newTab) {
            if (newTab) {
                this.model = `tab-${newTab}`;
            } else {
                this.$router.push({
                    path: this.$route.path,
                    query: { tab: null },
                });
            }
        },
    },
};
</script>
<style>
.mt5-accounts-tabs {
    --mt5-panel: #ffffff;
    --mt5-card: #ffffff;
    --mt5-field: #fbfaf6;
    --mt5-border: #e0e3e7;
    --mt5-text: #15181d;
    --mt5-muted: #626973;
    --mt5-primary: #d99a00;
    color: var(--mt5-text) !important;
    background: var(--mt5-panel) !important;
}
.theme--dark .mt5-accounts-tabs {
    --mt5-panel: #030b13;
    --mt5-card: #07111b;
    --mt5-field: #08131e;
    --mt5-border: #293026;
    --mt5-text: #f2f5fc;
    --mt5-muted: #aeb6c0;
    --mt5-primary: #ffc400;
}
.mt5-accounts-tabs .v-tabs-items,
.mt5-accounts-tabs .v-window-item { background: var(--mt5-panel) !important; }
.mt5-accounts-tabs > .v-tabs > .v-tabs-bar { border-bottom: 1px solid var(--mt5-border); }
.mt5-accounts-tabs > .v-tabs > .v-tabs-bar .v-tab {
    min-width: 110px;
    height: 38px;
    margin-right: 7px;
    padding: 0 17px !important;
    color: var(--mt5-muted) !important;
    border: 1px solid var(--mt5-border);
    border-radius: 5px 5px 0 0;
    font-size: 12px;
    letter-spacing: .4px;
    text-transform: none;
}
.mt5-accounts-tabs > .v-tabs > .v-tabs-bar .v-tab--active { color: var(--mt5-primary) !important; border-color: var(--mt5-primary); background: rgba(217, 154, 0, .06); }
.mt5-accounts-tabs .allTabs { margin-top: 18px !important; color: var(--mt5-text); }
.mt5-accounts-tabs .allTabs > .row:first-child { margin-right: 0; margin-bottom: 10px; margin-left: 0; background: transparent !important; }
.mt5-accounts-tabs .allTabs > .row:first-child > [class*="col-"] { padding: 3px 5px; }
.mt5-accounts-tabs .allTabs > .row:first-child > [class*="col-"]:first-child { padding-left: 0; }
.mt5-accounts-tabs .allTabs > .row:first-child > [class*="col-"]:last-child { padding-right: 0; }
.mt5-accounts-tabs .input-search,
.mt5-accounts-tabs .custom-select { background: transparent !important; }
.mt5-accounts-tabs .input-search .v-input__slot,
.mt5-accounts-tabs .custom-select .v-input__slot {
    min-height: 44px !important;
    color: var(--mt5-text) !important;
    border: 1px solid var(--mt5-border);
    border-radius: 7px !important;
    background: var(--mt5-field) !important;
    box-shadow: none !important;
    transition: border-color .18s ease, box-shadow .18s ease, background .18s ease;
}
.mt5-accounts-tabs .input-search.v-input--is-focused .v-input__slot,
.mt5-accounts-tabs .custom-select.v-input--is-focused .v-input__slot {
    border-color: var(--mt5-primary) !important;
    box-shadow: 0 0 0 2px rgba(217, 154, 0, .12) !important;
}
.mt5-accounts-tabs .input-search input,
.mt5-accounts-tabs .custom-select .v-select__selection { color: var(--mt5-text) !important; font-size: 12px; }
.mt5-accounts-tabs .input-search input::placeholder { color: var(--mt5-muted); opacity: 1; }
.mt5-accounts-tabs .input-search .v-input__prepend-inner { margin-right: 8px; }
.mt5-accounts-tabs .input-search .v-icon { color: var(--mt5-muted) !important; }
.mt5-accounts-tabs .custom-select .v-icon { color: var(--mt5-primary) !important; }
.mt5-accounts-tabs .live-account-card {
    min-height: 276px;
    padding: 13px 16px 12px;
    overflow: hidden;
    color: var(--mt5-text) !important;
    border: 1px solid var(--mt5-border);
    border-radius: 8px !important;
    background: var(--mt5-card) !important;
}
.mt5-accounts-tabs .live-account-card > .v-card__actions { min-height: 0; padding: 7px 0; }
.mt5-accounts-tabs .live-account-card > .v-card__actions:first-child { position: relative; min-height: 54px; padding-top: 0; padding-right: 84px; }
.mt5-accounts-tabs .live-account-card > .v-card__actions:nth-of-type(3) { display: none; }
.mt5-accounts-tabs .live-account-card > .v-card__actions:first-child::after {
    position: absolute;
    top: 6px;
    right: 34px;
    padding: 5px 9px;
    content: "Live";
    color: #18d78a;
    font-size: 9px;
    font-weight: 700;
    border-radius: 5px;
    background: rgba(24, 215, 138, .1);
}
.mt5-accounts-tabs .live-account-card:has(.text-red) > .v-card__actions:first-child::after {
    content: "Demo";
    color: #ff6574;
    background: rgba(255, 80, 96, .1);
}
.mt5-accounts-tabs .trade-dropdown { position: absolute; top: 3px; right: -7px; z-index: 2; }
.mt5-accounts-tabs .trade-status { display: flex; min-width: 0; align-items: center; gap: 12px; }
.mt5-accounts-tabs .trade-status > div:first-child {
    width: 42px;
    height: 42px;
    display: flex;
    flex: 0 0 42px;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    background: rgba(217, 154, 0, .08);
    border: 1px solid rgba(217, 154, 0, .28);
}
.mt5-accounts-tabs .trade-status > div:first-child .v-icon { color: var(--mt5-primary) !important; }
.mt5-accounts-tabs .trade-number { min-width: 0; display: flex; flex-direction: column; }
.mt5-accounts-tabs .trade-number > span:first-child { color: var(--mt5-text) !important; font-size: 13px; font-weight: 700; }
.mt5-accounts-tabs .trade-number > span:nth-child(2) { overflow: hidden; margin-top: 3px; color: var(--mt5-muted); font-size: 11px; font-weight: 500; text-overflow: ellipsis; white-space: nowrap; }
.mt5-accounts-tabs .trade-dropdown .v-icon { color: var(--mt5-text) !important; }
.mt5-accounts-tabs .value-trades,
.mt5-accounts-tabs .currency-leverage,
.mt5-accounts-tabs .balance-equity { min-width: 42%; display: flex; flex-direction: column; }
.mt5-accounts-tabs .value-trades span:first-child,
.mt5-accounts-tabs .currency-leverage span:first-child,
.mt5-accounts-tabs .balance-equity span:first-child { margin-bottom: 3px; color: var(--mt5-muted); font-size: 10px; font-weight: 400; }
.mt5-accounts-tabs .value-trades span:last-child,
.mt5-accounts-tabs .currency-leverage span:last-child,
.mt5-accounts-tabs .balance-equity span:last-child { color: var(--mt5-text); font-size: 13px; font-weight: 700; }
.mt5-accounts-tabs .live-account-card > .v-card__actions:nth-of-type(2) .value-trades span:last-child {
    font-size: 20px;
    line-height: 25px;
}
.mt5-accounts-tabs .live-account-card > .v-card__actions:nth-of-type(4) {
    padding-top: 10px;
    border-top: 1px solid var(--mt5-border);
}
.mt5-accounts-tabs .live-account-card > .v-card__actions:nth-of-type(5) { margin-top: 3px; padding-top: 10px; border-top: 1px solid var(--mt5-border); }
.mt5-accounts-tabs .live-account-card > .v-card__actions:last-child { padding-top: 10px; }
.mt5-accounts-tabs .live-account-card .blink {
    height: 34px;
    color: var(--mt5-primary) !important;
    border-color: var(--mt5-primary) !important;
    font-size: 11px;
    font-weight: 650;
    letter-spacing: 0;
    text-transform: none;
}
.mt5-accounts-tabs .live-account-card .blink::before { background: var(--mt5-primary); }
.mt5-accounts-tabs .investment-type { color: var(--mt5-muted); border-color: var(--mt5-border); }
.mt5-accounts-tabs .text-center { color: var(--mt5-muted); }
@media (max-width: 700px) {
    .mt5-accounts-tabs,
    .mt5-accounts-tabs > .v-tabs,
    .mt5-accounts-tabs .v-tabs-items,
    .mt5-accounts-tabs .v-window,
    .mt5-accounts-tabs .v-window__container { width: 100%; min-width: 0; }
    .mt5-accounts-tabs > .v-tabs > .v-tabs-bar,
    .mt5-accounts-tabs > .v-tabs > .v-tabs-bar .v-slide-group {
        width: 100% !important;
        max-width: 100% !important;
        height: 44px;
        overflow: hidden;
    }
    .mt5-accounts-tabs > .v-tabs > .v-tabs-bar .v-slide-group__prev,
    .mt5-accounts-tabs > .v-tabs > .v-tabs-bar .v-slide-group__next { display: none !important; }
    .mt5-accounts-tabs > .v-tabs > .v-tabs-bar .v-slide-group__wrapper {
        width: 100% !important;
        min-width: 0 !important;
        flex: 1 1 100% !important;
        overflow: hidden !important;
    }
    .mt5-accounts-tabs > .v-tabs > .v-tabs-bar .v-slide-group__content {
        width: 100% !important;
        min-width: 0 !important;
        flex: 1 1 100% !important;
        transform: none !important;
    }
    .mt5-accounts-tabs > .v-tabs > .v-tabs-bar .v-tab {
        min-width: 0 !important;
        max-width: none !important;
        margin-right: 5px;
        padding: 0 5px !important;
        flex: 1 1 0 !important;
        white-space: nowrap;
    }
    .mt5-accounts-tabs > .v-tabs > .v-tabs-bar .v-tab:last-child { margin-right: 0; }
    .mt5-accounts-tabs .allTabs { margin-top: 12px !important; }
    .mt5-accounts-tabs .allTabs > .row:first-child { display: flex; margin-bottom: 12px; flex-direction: column; }
    .mt5-accounts-tabs .allTabs > .row:first-child > [class*="col-"] {
        width: 100%;
        max-width: 100%;
        flex: 0 0 100%;
        padding: 4px 0 !important;
    }
    .mt5-accounts-tabs .input-search .v-input__slot,
    .mt5-accounts-tabs .custom-select .v-input__slot { width: 100%; min-height: 44px !important; }
    .mt5-accounts-tabs .live-account-card { width: 100%; min-height: 270px; padding: 13px 15px 12px; }
    .mt5-accounts-tabs .live-account-card > .v-card__actions:first-child { min-height: 62px; padding-right: 68px; }
    .mt5-accounts-tabs .trade-status { gap: 10px; }
    .mt5-accounts-tabs .trade-status > div:first-child { width: 42px; flex-basis: 42px; }
    .mt5-accounts-tabs .trade-number > span:first-child { font-size: 13px; line-height: 17px; white-space: normal; }
    .mt5-accounts-tabs .trade-number > span:nth-child(2) { white-space: normal; overflow-wrap: anywhere; }
    .mt5-accounts-tabs .value-trades,
    .mt5-accounts-tabs .currency-leverage,
    .mt5-accounts-tabs .balance-equity { min-width: 0; width: 46%; }
}
</style>
